<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>[{{model.type && model.type.value ? model.type.value.toUpperCase() : model.type.toUpperCase()}}]</strong>
            <strong>{{model.title}}</strong> <span class="float-right">{{model.created_at | sdate}}</span>
          </div>
          <b-row>
            <b-col md="12">
              <v-select label="text" :disabled="lock" v-model="model.type" :options="codes.BOARD_TYPE_DICT"></v-select>
              <!-- <select v-model="model.type" class="w-100" :disabled="lock">
                <option disabled value="">Please select solution</option>
                <option value="wmds">WMDS : Web Malware Detection System</option>
                <option value="wsfinder">WSFinder : WeShell Finder</option>
                <option value="webcastle">WEBCastle : Web Firewall</option>
              </select> -->
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_title">Title</label>
                <b-form-input md=5 type="text" id="ph_title" :disabled="lock" v-model="model.title"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <h4 for="ph_question">Content</h4>
              <vue-editor v-model="model.content" :disabled="lock" id="ph_question"></vue-editor>
            </b-col>
          </b-row>
          <hr>
          <b-button size="sm" v-if="!lock" variant="success" @click="save"> Save </b-button>
          <b-button size="sm" v-else variant="warning" @click="edit"> Edit </b-button>
          <b-button size="sm" v-if="!lock && !add" variant="default" @click="cancel"> Cancel </b-button>
          <b-button size="sm" v-if="lock && model.id" variant="danger" @click="confirm = true"> Remove </b-button>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm" @ok="remove(model)" ok-variant="danger">
      Are you sure you want to delete the data?
    </b-modal>
    <!-- {{model}} -->
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { Api } from '@/service';
import vSelect from 'vue-select';
import  codes from '@/codes';

export default {
  components: { VueEditor, vSelect },
  data : () => ({ codes, confirm: false, add: false, lock: true, model : { type : '' } }),
  methods: {
    cancel() { this.lock = true; },
    edit() { this.lock = false; },
    async remove() {
      try {
        let rs = await Api.Manager_Call('board.faq', 'remove', { id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name)
        } else {
          console.log("remove", 'failed', rs.reason, this.model.id)
          this.$toastr.e('remove', "failed")
        }
        this.list(); this.$emit('refresh')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    async save() {
      if(!(this.model.type && this.model.type.value ? this.model.type.value : '').trim()) { return this.$toastr.e('Solution is Require.'); }
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is Require.'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is Require.'); }

      let model = this.model
      model.type = this.model.type.value

      try {
        let rs = await Api.Manager_Call('board.faq', this.model.id ? 'update' : 'insert', model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.$emit("refresh")
          // this.$router.push({ name : 'board_faq', params : { id : rs.body.id } });
        } else {
          this.$toastr.s('Save', 'failed');
        }
        this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    list() { this.$router.push({ name: 'board_faq'}); },
    async get({id, tag } = this.$route.params) {
      console.log('faq.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try { let rs = await  Api.Manager_Call('board.faq', 'detail', { id : id }); this.model = rs.body }
      catch(e) { this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('faq.detail.vue', 'created'); },
  destroyed() { console.log('faq.detail.vue', 'destroyed'); },
  mounted() { console.log('faq.detail.vue', 'mounted'); this.get(this.$route.params); },
}
</script>
